import React, { useEffect, useRef, useState } from 'react';
import { useFirestore } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import SelectCountry from '../generalComponets/SelectCountry';
import SelectCompany from '../generalComponets/SelectCompany';
import { dateToStringWithHour } from '../../utils/DateUtil';
import { messageTemplatesRef } from '../../api/fbCollections';

function MessageStatistics(props) {
  const options = ['By Template', 'By Company'];
  const [messageTemplates, setMessageTemplates] = useState([]);
  const [mTemplates, setMTemplates] = useState([]);
  const [country, setCountry] = useState(null);
  const [option, setOption] = useState(options[0]);
  const [forceUpdate, setForceUpdate] = useState(0);
  const firestore = useFirestore();
  const selectCompanyRef = useRef();

  useEffect(() => {
    firestore
      .collection(messageTemplatesRef)
      .orderBy('createdAt', 'asc')
      .get()
      .then((querySnapshot) => {
        const data = [];
        querySnapshot.forEach((doc) => {
          data.push({ id: doc.id, ...doc.data() });
        });
        setMTemplates(data);
      })
      .catch((e) => console.log(e.message));
  }, [firestore]);

  const changeOptionSendTo = (option) => {
    setOption(option);
    setForceUpdate(forceUpdate + 1);
  };

  const changeCompany = (company) => {
    const messages = mTemplates.filter((m) => m.companyId === company.id);
    console.log(messages);
    setMessageTemplates(messages);
  };

  const renderOptions = () => (
    <div className="row">
      <label className="col s6">
        <input
          name="answers"
          type="radio"
          onChange={() => changeOptionSendTo(options[0])}
          checked={option === options[0] ? 'checked' : ''}
        />
        <span className="radio-option">{options[0]}</span>
      </label>
      <label className="col s6">
        <input
          name="answers"
          type="radio"
          onChange={() => changeOptionSendTo(options[1])}
          checked={option === options[1] ? 'checked' : ''}
        />
        <span className="radio-option">{options[1]}</span>
      </label>
    </div>
  );

  const renderFilter = () => {
    if (option === options[0]) {
      return <div />;
    }
    return (
      <div>
        <SelectCountry changeCountry={setCountry} />
        <SelectCompany ref={selectCompanyRef} country={country} changeCompany={changeCompany} />
      </div>
    );
  };

  const renderMessageTemplates = () => {
    const templates = option === options[0] ? mTemplates : messageTemplates;
    return (
      <div>
        {templates.map((m) => (
          <div key={m.id} className="card" onClick={() => props.history.push(`/messageStatistic/${m.id}`)}>
            <div className="card-content">
              <p>Id: {m.id}</p>
              <p>Title: {m.title}</p>
              <p>Message: {m.message}</p>
              <p>Created At: {dateToStringWithHour(m.createdAt.toDate())}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="container">
      <div className="title-section">Message Statistics</div>
      <div className="row">
        <div className="col s6">
          {renderOptions()}
          {renderFilter()}
        </div>
        <div className="col s6">{renderMessageTemplates()}</div>
      </div>
    </div>
  );
}

export default withRouter(MessageStatistics);
